module.exports = __webpack_public_path__ + "img/2025-07-21a_2.8a4f8738.jpg";